import { render, staticRenderFns } from "./suspended_ball.vue?vue&type=template&id=51ae14da"
import script from "./suspended_ball.vue?vue&type=script&lang=js"
export * from "./suspended_ball.vue?vue&type=script&lang=js"
import style0 from "./suspended_ball.vue?vue&type=style&index=0&id=51ae14da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports